module.exports = __webpack_public_path__ + "img/trip-end.df974de5.svg";